import { FormattedMessage, useIntl } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";

const BusinessContinuityAndDisasterRecovery = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "ConfluencePricingPage.modal-content.business-continuity.title",
            defaultMessage: "Business continuity and disaster recovery"
        }),
        body: intl.formatMessage({
            id: "ConfluencePricingPage.modal-content.business-continuity.body",
            defaultMessage:
                "Our Disaster Recovery Program consists of a few key practices to ensure the appropriate levels of governance, oversight, and testing."
        })
    };

    return (
        <div>
            <h2>{messages.title}</h2>
            <p>{messages.body}</p>
            <div>
                <FormattedMessage
                    id="ConfluencePricingPage.modalContent.businessContinuityAndDisasterRecovery.cta"
                    defaultMessage="<a>Learn more</a> about security practices."
                    values={{
                        ...DEFAULT_VALUES,
                        a: (chunks: React.ReactNode) => (
                            <a
                                // eslint-disable-next-line react-hooks/rules-of-hooks
                                href={useLocalizedHref(
                                    "/trust/security/security-practices#security-in-day-to-day-operations"
                                )}
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="confluence"
                                data-track-event="ConfluencePricingPage.BusinessContinuityAndDisasterRecovery"
                                data-event-container="ConfluencePricingPage"
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </div>
        </div>
    );
};

export default BusinessContinuityAndDisasterRecovery;
